import { AbstractAddEntityCommandFactory } from "./AbstractAddEntityCommandFactory";

export class AddEntityCommandFactory<TSource, TEntityBase, TEntity extends TEntityBase> extends AbstractAddEntityCommandFactory<TSource, TEntityBase, TEntity> {
  constructor(entity: TEntity | AddEntityCommandFactory<TSource, TEntityBase, TEntity>, toEntities: (s: TSource) => TEntityBase[]) {
    super(entity);
    this._toEntities = (entity instanceof AddEntityCommandFactory)
      ? entity._toEntities
      : toEntities;
  }

  private readonly _toEntities: (s: TSource) => TEntityBase[];

  protected toEntities(source: TSource): TEntityBase[] {
    return this._toEntities(source);
  }
}
